import { HttpResponse, http } from 'msw';
import { mockedOrders } from '../mocks/API/orders.api';
import type { APIRespPaginated } from '../../types/APIService';
import type { Order } from '../../types/Order';
import { getAPIUrl } from '../../utils/getApiUrl';

const res: APIRespPaginated<Order[]> = {
  status: 'success',
  data: {
    data: mockedOrders,
    total_count: mockedOrders.length,
    pages: 1,
  },
  message: '',
};
const API_URL = getAPIUrl();

// Define the handlers for the order endpoints
export const ordersHandlers = [
  http.get(`${API_URL}orders`, () => {
    return HttpResponse.json(res);
  }),
  http.get(`${API_URL}admin/orders`, () => {
    return HttpResponse.json(res);
  }),
];
